import { createTheme } from '@material-ui/core/styles';

const breakpoints = {
  values: {
    xs: 320,
    sm: 360,
    md: 410,
    lg: 640,
    xl: 1024,
  },
};

const createThemeBreakpoints = createTheme({
  breakpoints,
});

const defaultTheme = createTheme({
  breakpoints,
  spacing: 4,
  palette: {
    text: {
      primary: '#333333',
      secondary: '#67676d',
      disabled: 'rgb(21, 21, 30, 0.5)',
    },
    background: {
      default: 'rgb(247, 244, 241, 1)', // #F7F4F1
    },
    primary: {
      light: '#EE0000',
      main: '#EE0000',
      dark: '#EE0000',
    },
    secondary: {
      light: '#3497ff',
      main: '#1976d2',
      dark: '#3497ff',
    },
    error: {
      light: '#EE0000',
      main: '#EE0000',
      dark: '#EE0000',
      contrastText: '#ffffff',
    },
    custom: {
      black: '#000000',
      grayBg: '#DFDFDF',
      grayHighlight: '#EBEBEB',
      yellowButton: '#FFCE1B',
      darkTransparent: 'rgba(0, 0, 0, 0.5)',
      frame: '#d0d0d2',
      white: '#FFFFFF',
      darkGreyBg: '#38383f',
      darkRed: '#e00',
      lightBlack: '#15151e',
      lightGrayishRed: '#F2DEDE',
      darkBlue: '#23527c',
      divider: '#d0d0d2',
      f1Red: '#DF0501',
      f1InputHighlight: '#9ecaed',
    },
  },
  stripe: {
    typography: {
      fontFamily: 'Titillium Web',
    },
  },
  typography: {
    fontFamily: 'TitilliumWeb-Regular',
    h2: {
      fontFamily: 'Formula1-Bold',
      fontSize: '32px',
      fontWeight: '500',
      color: '#333333',
      letterSpacing: '0.2px',
      [createThemeBreakpoints.breakpoints.down('md')]: {
        fontSize: '22px',
      },
    },
    h5: {
      fontSize: '17px',
      fontWeight: '700',
      letterSpacing: '0.2px',
      WebkitFontSmoothing: 'auto',
    },
    h6: {
      fontSize: '15px',
      fontWeight: '600',
      WebkitFontSmoothing: 'auto',
    },
    body1: {
      fontSize: '17px',
      letterSpacing: '0.2px',
      WebkitFontSmoothing: 'auto',
    },
    body2: {
      fontSize: '15px',
      WebkitFontSmoothing: 'auto',
    },
    subtitle1: {
      fontSize: '15px',
      WebkitFontSmoothing: 'auto',
    },
    button: {
      fontSize: '13px',
      fontWeight: '400',
      letterSpacing: '0.5px',
      WebkitFontSmoothing: 'auto',
    },
  },
  overrides: {
    MuiInput: {
      root: {
        border: `1px solid #000000`,
        borderRadius: '10px',
        // marginBottom: '16px',
        backgroundColor: '#fff',
        height: '54px',
      },
      input: {
        marginLeft: '12px',
      },
    },
    MuiFormControl: {
      root: { width: '100%' },
    },
    MuiButton: {
      root: {
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingTop: '9px',
        paddingBottom: '9px',
      },
    },
    MuiDivider: {
      root: {
        width: '100%',
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#1aa3ff',
        },
      },
    },
    MuiInputLabel: {
      root: {
        marginBottom: '4px',
        marginLeft: '12px',
      },
    },
    MuiPaginationItem: {
      root: {
        fontFamily: 'Formula1-Regular',
        fontSize: '12px',
      },
    },
    MuiNativeSelect: {
      root: {
        marginLeft: '0px',
        paddingLeft: '12px',
        color: '#15151e',
      },
      select: {
        backgroundColor: '#ffffff',
        fontSize: '15px',
        '&:focus': {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiCssBaseline: {
      '@global': {
        '.panel': {
          border: 'solid 2px #d0d0d2',
          backgroundColor: ' #fff',
          borderRadius: '5px',
          [createThemeBreakpoints.breakpoints.down('md')]: {
            borderRadius: '10px',
          },
        },
        '.panel-default': {
          marginBottom: '20px',
        },
        '.panel-heading': {
          margin: '20px',
          padding: '10px 0 20px 0',
        },
        '.panel-body': {
          padding: '15px',
        },
        '.form-group': {
          marginBottom: '15px',
        },
        a: {
          borderBottom: 'solid 2px #ee0000',
          color: '#15151e',
          textDecoration: 'none',
          fontWeight: '500',
          '&:hover': {
            color: '#ee0000',
          },
        },
      },
    },
  },
});

export { defaultTheme };
